<script>
export default {
   name: "privacy",
   metaInfo: {
      title: "Privacy Policy",
      titleTemplate: "%s | Juilliard Creative Classroom"
   },
   props: [],
   components: {},
   data() {
      return {};
   },
   computed: {},
   methods: {},
   mounted() {}
};
</script>

<template>
   <section class="privacy-page basic-content">
      <h1>Privacy Policy</h1>
      <h2>Juilliard Creative Classroom Privacy Policy</h2>
      <p class="sans">
         The Juilliard School (referred to herein as “Juilliard” or “we,” “us,”
         “our” and other similar pronouns) cares about your privacy. This
         privacy policy (the “Policy”) applies to Juilliard Creative Classroom
         (the “Website”), a private digital repository of educational resources
         for teachers working with students ages 4-18. Our materials have been
         designed to enhance and supplement existing school programs around the
         globe. We created this privacy policy (“Policy”) to explain the type of
         information we collect and how we will use it.
      </p>
      <p class="sans">
         Please read this Policy carefully before using the Website. By using
         the Website in any manner, your actions constitute an act of acceptance
         of, and agreement to be bound by, the terms of this Policy. This Policy
         is incorporated into the Terms of Use (the “Terms of Use”), available
         <a
            href="https://juilliardcreativeclassroom.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            >here</a
         >, which is incorporated herein by reference, and your access to and
         use of the Website are
      </p>
      <h3>Information We Collect & How We Use It</h3>
      <p class="sans">
         We collect and store your email address solely for purposes of allowing
         you access to the Website. We do not collect any other personal
         information and do not share that information with third parties. You
         may update the information that we have on file for you at any time by
         sending us an email at
         <a href="mailto:K12PROGRAMS@JUILLIARD.EDU">K12PROGRAMS@JUILLIARD.EDU</a
         >.
      </p>
      <h4 class="sans">Information Gathered Automatically</h4>
      <p class="sans">
         When you visit a Website, some information is automatically collected
         by us. For example, our servers automatically collect your IP address
         when you visit this Website, and we may associate that with your domain
         name or that of your Internet access provider. We receive data from or
         about the computer and/or mobile device that you use to access and/or
         install the Website, including data about the computer’s or mobile
         device’s operating system and the browser used to access the Website.
         We may also capture certain “clickstream data” pertaining to your site
         usage (such information referred to as “Website Usage Information”).
         Clickstream data includes, for example, information about your computer
         or mobile device, web browser and operating system and their settings,
         the pages, and content that you see or click on during your visit and
         when and for how long you do so, items you download, and any search
         terms you have entered on the Website. We may record your interactions
         with the Website, view any information that you may enter into the
         Website’s fields and create video recordings of your user session. Such
         video recordings capture your interactions with the Website (such as
         the movements of your cursor, the pages of the Website you visit and
         any information you may enter into the Website’s fields). Such video
         recordings do not capture your interactions with other websites or your
         interactions with your computer or mobile device that are unrelated to
         the Website.
      </p>
      <p class="sans">
         In addition, we may deploy various tracking technologies on the Website
         to collect additional information about your Website visits. For
         example:
      </p>
      <ul>
         <li>
            Cookies: Cookies are small data files stored on your computer or
            device at the request of a website. A cookie assigns a unique
            numerical identifier to your web browser, and may enable us to
            recognize you as the same user who was at this Website in the past,
            and relate your use of the Website to other information about you,
            such as your Website Usage Information and Personal Information.
            Cookies may also be used to enhance your experience on a Website
            (for example, by storing your username so you can log in easily,
            keeping you logged into the Website after you have provided your
            password, and storing the contents of your shopping cart as you
            browse) or to collect general usage and aggregated statistical
            information and detect and prevent fraud. Most browsers can be set
            to detect cookies and give you an opportunity to reject them, but
            refusing cookies may, in some cases, inhibit or preclude your use of
            the Website or its features. To learn more about the use of cookies,
            including how to manage or delete them, click here.
         </li>
         <li>
            HTML5: HTML5 (the language some websites are coded in) may be used
            to store information on your computer or device about your Website
            usage activities. This information can be retrieved by us to
            determine how this Website is being used by our visitors, how it can
            be improved, and to customize it for our users.
         </li>
      </ul>
      <p class="sans">
         These tracking technologies may be deployed by us and/or by our service
         providers on our behalf. These technologies enable us to assign a
         unique number to you, and relate your Website Usage Information to
         other information about you, including your Personal Information.
      </p>
      <p>
         By using this Website, you consent to our use of these tracking
         technologies as described above.
      </p>
      <h3 class="sans">How is your information used?</h3>
      <p class="sans">
         We and our service providers may use the information we collect from
         and about you to perform a variety of functions, including the
         following:
      </p>
      <ul>
         <li>enabling users to use this Website and its features</li>
         <li>developing new offerings</li>
         <li>administering our Website and your account with us</li>
         <li>responding to your requests, questions, and concerns</li>
         <li>
            informing users about the availability of new features and offerings
         </li>
         <li>
            facilitating the provision of software updates and product support
            for applications and programs
         </li>
         <li>
            informing users of the availability of content supplements for
            existing applications
         </li>
         <li>protecting our rights and property</li>
         <li>to prevent fraud</li>
         <li>
            other purposes disclosed when Personal Information is submitted to
            us
         </li>
      </ul>
      <p class="sans">
         We may match information collected from you through different means or at different times, including both Personal Information and Website Usage Information, and use such information along with information obtained from other sources (including third parties) as described above. We or our service providers may also use your information to assess the level of interest in, and use of, our digital products, Websites, our emails and our other messaging campaigns both on an individual basis and in the aggregate.
      </p>
      <h3>Opt In and Opt Out</h3>
      <p class="sans">We use Google Analytics to generate anonymized analytics reports on the usage of this Website.  To opt out of your Website Usage Information being included in our Google analytics reports, you may follow <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">these instructions</a>. To learn more about Google Analytics, please visit the Google Analytics Privacy Overview.
         <p class="sans">Please understand that it may take us a few days to process any opt out request and that even if you opt out of receiving certain correspondence from us, we may still contact you in connection with your relationship, activities, transactions and communications with us.</p>
      </p>
      <h3>Security</h3>
      <p class="sans">While we endeavor to protect the security and integrity of your personal information collected via our Website, due to the inherent nature of the Internet as an open global communications vehicle, we cannot guarantee that any information, during transmission through the Internet or while stored on our system or otherwise in our care, will be absolutely safe from intrusion by others, such as hackers. If you correspond with us by email, you should be aware that your transmission might not be secure. A third party could view the information you send in transit by such means. We will have no liability for disclosure of your information due to errors or unauthorized acts of third parties during or after transmission.</p>
      <p class="sans">If we believe that the security of your personal information in our care may have been compromised, we may seek to notify you of that development, if appropriate. <b>You consent to our use of email as a means of such notification.</b></p>
      <h3>Use by Children</h3>
      <p class="sans">The Website is intended solely for users who are thirteen (13) years of age or older. We do not knowingly collect personal information from users under thirteen (13).</p>

      <h3>Updates to this Privacy Policy</h3>
      <p class="sans">We reserve the right to change this Privacy Policy from time to time, and such changes will be effective immediately upon posting on this page. We will notify you of material changes to this Policy by posting the revised Policy with the date it was revised on this page. We encourage you to periodically review this Privacy Policy to stay informed about how we are protecting and using the information we collect.</p>

      <h3>Contact Us</h3>
      <p class="sans">If you have any questions or comments regarding our privacy practices, you may contact us at <a href="mailto:WEB.MASTER@JUILLIARD.EDU">WEB.MASTER@JUILLIARD.EDU</a></p>
      <p class="sans"><b>Last updated: June 2021</b></p>
   </section>
</template>
